import axios from "axios";
import React, { useState } from "react";
import Button from "../../shared/Button";
import ButtonPrimary from "../../shared/Button/ButtonPrimary";
import Dropdown from "../../shared/DropDown/DropDown";
import Modal from "../../shared/Modal";
import Status from "../../shared/Status";
import { DropDownOpts, IBlog } from "../../types/blogType";

type BlogCardProps = {
	data: Partial<IBlog>;
};

const BlogCard = ({ data: blogData }: BlogCardProps) => {
	const [open, setOpen] = useState<boolean>(false);
	const [action, setAction] = useState<"edit" | "delete">("edit");

	const handleClick = () => {
		setOpen(!open);
	};
	const blogopts: DropDownOpts[] = [
		{
			name: "Edit",
			href: `/dashboard/blog/${blogData.href}`,
		},
		{
			name: "Change Status",
			onClick: () => {
				setAction("edit");
				setOpen(true);
			},
		},
		{
			name: "Delete",
			onClick: () => {
				setAction("delete");
				setOpen(true);
			},
		},
	];

	const handleStatus = (status: "draft" | "published" | "deleted") => () => {
		axios
			.patch(
				`/api/blog/${blogData._id}`,
				{
					...blogData,
					status,
				},
				{
					withCredentials: true,
				}
			)
			.then((res) => {
				blogData.status = status;
				setOpen(false);
			})
			.catch((err) => console.log(err));
	};

	const renderChangeStatus = () => {
		return (
			<div className="flex gap-x-3 w-fit">
				<Button onClick={handleClick}>Back</Button>
				<ButtonPrimary
					onClick={handleStatus(
						blogData.status === "draft" ? "published" : "draft"
					)}
				>
					Yes
				</ButtonPrimary>
			</div>
		);
	};

	const renderDelete = () => {
		return (
			<div className="flex gap-x-3 w-fit">
				<Button onClick={handleClick}>Back</Button>
				<ButtonPrimary
					onClick={handleStatus("deleted")}
					className="!bg-red-400"
				>
					Yes
				</ButtonPrimary>
			</div>
		);
	};

	return (
		<>
			<Modal
				open={open}
				handleOpen={handleClick}
				title={
					action === "edit"
						? `Change to ${
								blogData.status === "draft" ? "published" : "draft"
						  }?`
						: "Delete Blog?"
				}
			>
				{action === "edit" ? renderChangeStatus() : renderDelete()}
			</Modal>
			<div className="bg-white px-6 py-6 rounded-lg duration-500 group flex-col">
				<div className="mb-3 rounded-lg h-52 w-full  relative overflow-hidden">
					<img
						src={blogData.image}
						className="flex-shrink-1 object-cover absolute h-full w-full rounded-lg group-hover:scale-125 duration-1000 group-hover:grayscale-0 grayscale "
						alt={blogData.title || ""}
					></img>
				</div>
				<div className="my-3">
					<h3 className="font-bold text-lg">{blogData.title}</h3>
					<p className="text-sm">{blogData.subtitle}</p>
				</div>
				<div className="flex flex-1 justify-between">
					{" "}
					<Status status={blogData.status} fontSize="text-sm"></Status>
					<Dropdown content={blogopts} />
				</div>
			</div>
		</>
	);
};

const defaultProps: BlogCardProps = {
	data: {
		title: "-",
		subtitle: "-",
		image:
			"https://images.pexels.com/photos/417173/pexels-photo-417173.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
	},
};
BlogCard.defaultProps = defaultProps;

export default BlogCard;
